'use strict';

// Add init function that is executed only on first dom-ready (it should contain only document/body delegate handlers)
mpro.addInitDelegate(($) => {

	const $B = mpro.get$B();
	const $W = mpro.get$W();
	const shareSelector = '[data-share]';

	const $shareButton = $B.find(shareSelector);

	if (navigator.share && mpro.isMobileScreen()) {
		$shareButton.show();

		$B.on('click', shareSelector, function (e) {
			e.preventDefault();
			const $button = $(this);

			navigator.share({
				title: $button.data('title'),
				url: $button.data('url'),
			}).then(() => {
				// Success message
			}).catch(console.error);
		});
	}
	else {
		$shareButton.hide();
	}
});
